import { plainToClass } from "class-transformer";
import { SiteLevelSummaryDto } from "../../sites/sites.objects";
import { InitializeFilterDropdown } from "../../../../shared/scripts/filtering/filtering.utilities";
import { Unique } from "../../../../shared/scripts/array-functions";
import { CTMSMilestonesTable } from "./ctms-milestones-table";
import { AuditHistoryDialog } from "../../audit/scripts/audit-history.dialog";

export class CTMSStudyDetailsPage {
    studyId: number;
    sites: SiteLevelSummaryDto[];
    dataTable: any;
    filterDropdownIds: string[];
    token: string;
    milestonesTable: CTMSMilestonesTable;
    selectedMilestonesTable: any;
    allMilestonesJson: any;
    checkedSiteIds: Set<number> = new Set();
    allSiteSettings: any[] = [];
    assignedSites: number[] = [];
    editStudySitesTable: any;

    constructor(studyId: number, allSitesJson: any, allMilestonesJson: any) {
        $(() => {
            this.token = document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value');
            this.sites = plainToClass(SiteLevelSummaryDto, <SiteLevelSummaryDto[]>allSitesJson);
            this.sites = this.sites.map((site: SiteLevelSummaryDto) => {
                site.initialize();
                return site;
            });
            this.studyId = studyId;
            this.filterDropdownIds = ['#study-dropdown', '#site-manager-dropdown', '#study-status-dropdown'];
            this.allMilestonesJson = allMilestonesJson;
            this.initializeFilters();
            this.initializeTable();
            this.initializeModal();
            this.initSelectedMilestonesTable();
            this.milestonesTable = new CTMSMilestonesTable(allMilestonesJson, this.studyId);
            this.setupEditMilestonesDialog();
            this.setupEditStudyDialog();
            this.setupEditStudySiteButton();
            this.setupSaveStudySiteAssignment();
            $('#newSiteDialog').on('shown.bs.modal', () => {
                if (this.editStudySitesTable) {
                    this.editStudySitesTable.columns.adjust();
                }
            });
        });
    }

    initializeFilters(): void {
        this.filterDropdownIds.forEach((dropdownId: string) => {
            $(dropdownId).empty();
        });

        let studyValues: string[] = [];
        this.sites.forEach((site: SiteLevelSummaryDto) => { studyValues.push(...site.StudyList); });
        InitializeFilterDropdown('#study-dropdown', Unique(studyValues, true, ["None Selected"]), this);

        let values: string[] = [];
        this.sites.forEach((site: SiteLevelSummaryDto) => { values.push(...site.UserNames); });
        values.push("Unassigned");
        InitializeFilterDropdown('#site-manager-dropdown', Unique(values, true, ["None Selected"]), this);

        let statusValues: string[] = [];
        this.sites.forEach((site: SiteLevelSummaryDto) => { statusValues.push(...site.StudyStatuses); });
        InitializeFilterDropdown('#study-status-dropdown', Unique(statusValues, true, ["None Selected"]), this);

    }

    initializeTable(): void {
        this.dataTable = $('#sites-table').DataTable({
            "dom": 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '60vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[0, 'asc']],
            columns: [
                { data: { _: "SiteNumber", sort: "SiteNumber" }, title: "Site Number" },
                { data: { _: "SiteName", sort: "SiteName" }, title: "Site Name" },
                {
                    data: "UserNames",
                    title: "Site Manager",
                    render: function (data) {
                        return Array.isArray(data) ? data.join(", ") : "";
                    }
                },
                {
                    data: null,
                    title: "Studies",
                    render: function (data, type, row) {
                        if (row.CTMSStudy && row.CTMSStudy.length > 0) {
                            return row.CTMSStudy
                                .map(ss => ss.Name ? ss.Name : "")
                                .filter(name => name)
                                .sort()
                                .join(", ");
                        }
                        return "";
                    }
                },
                {
                    data: null,
                    title: "",
                    className: "ctms-table-col-actions",
                    orderable: false,
                    render: function (data, type, row) {
                        return `<a href="/secure/ctms/site-details?id=${row.Id}" title="Edit"><i class="ctms-icon-pencil"></i></a>`;
                    }
                }
            ],
            data: this.sites,
        });

        $('#custom-dt-search').on('input', function () {
            $('#sites-table').DataTable().search(String($(this).val() ?? '')).draw();
        });
        $('#clear-custom-dt-search').on('click', function () {
            $('#custom-dt-search').val('');
            $('#sites-table').DataTable().search('').draw();
        });
    }

    updateTable(matchingSites: SiteLevelSummaryDto[]): void {
        this.dataTable.clear();
        this.dataTable.rows.add(matchingSites).draw();
    }

    triggerFilter(): void {
        let matchingSites: SiteLevelSummaryDto[] = [];
        let siteMatches: boolean;
        this.sites.forEach((site: SiteLevelSummaryDto) => {
            siteMatches = true;
            if (!site.matchesFilter(this.getSelectedDropdownValues('#study-dropdown'), this.getSelectedDropdownValues('#site-manager-dropdown'), this.getSelectedDropdownValues('#study-status-dropdown'))) {
                siteMatches = false;
            }
            if (siteMatches) { matchingSites.push(site); }
        });
        this.updateTable(matchingSites);
    }

    getSelectedDropdownValues(selectId: string): any {
        return $(selectId).val();
    }

    resetFilters(): void {
        this.filterDropdownIds.forEach((dropdownId: string) => {
            $(dropdownId).selectpicker('selectAll');
            $(dropdownId).selectpicker('refresh');
        });
        $('#custom-dt-search').val('');
        this.dataTable.search('').draw();
        this.updateTable(this.sites);
    }

    initializeModal() {
        $('#newSiteDialog').modal({
            backdrop: 'static',
            show: false,
        });

        $('#addSiteButton').on('click', () => {
            this.openAddModal();
        });

        $('#newSiteDialog .ctms-button-save').on('click', (e) => {
            const f = document.getElementById('siteDialogForm') as HTMLFormElement;

            if (f.checkValidity()) {
                $('#siteDialogForm').removeClass('ctms-invalid-form');
                $('#newSiteDialog .ctms-button-save').prop('disabled', true);
                $('#studySiteAssignmentSaveSpinner').show();
                $.ajax({
                    url: `/secure/ctms/sites/sites?handler=AddSite`,
                    headers: { "RequestVerificationToken": this.token },
                    type: 'POST',
                    data: $('#newSiteDialog .ctms-field-submit').serialize(),
                    success: (resp) => {
                        const newSite = plainToClass(SiteLevelSummaryDto, <SiteLevelSummaryDto>resp);
                        newSite.initialize();
                        this.sites.push(newSite);
                        this.resetFilters();
                        $('#newSiteDialog').modal('hide');
                    },
                    complete: () => {
                        $('#newSiteDialog .ctms-button-save').prop('disabled', false);
                        $('#studySiteAssignmentSaveSpinner').hide();
                    }
                });
            } else {
                $('#siteDialogForm').addClass('ctms-invalid-form');
            }

            e.preventDefault();
            e.stopPropagation();
        });

        $('#newSiteDialog').on('hidden.bs.modal', () => {
            $('#siteDialogForm').removeClass('ctms-invalid-form');
        });
    }

    async openAddModal() {
        $('#siteDialogForm').removeClass('ctms-invalid-form');

        $('#newSiteDialog .ctms-field-submit').each((i, e) => {
            if (e.getAttribute('type') === 'text') {
                $(e).val('');
            }
            if (e.getAttribute('type') === 'checkbox') {
                $(e).prop('checked', false);
            }
        });

        const studyCheckbox = $(`#newSiteDialog input[type="checkbox"][data-study-id="${this.studyId}"]`);
        if (studyCheckbox.length) {
            studyCheckbox.prop('checked', true);
            studyCheckbox.off('click.ctmsLock').on('click.ctmsLock', function (e) {
                if (!$(this).prop('checked')) {
                    $(this).prop('checked', true);
                }
                e.preventDefault();
                return false;
            });
        }

        $('#newSiteDialog').modal('show');
    }

    initSelectedMilestonesTable() {
        // Only show selected milestones, sorted by Order
        const selectedMilestones = this.allMilestonesJson
            .filter(m => m.StudyMilestoneId && m.StudyMilestoneId !== 0 && m.StudyMilestoneId !== null);
        this.selectedMilestonesTable = $('#selected-milestones-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '40vh',
            scrollCollapse: true,
            orderCellsTop: true,
            columns: [
                { data: 'Order', title: 'Order', width: '100px' },
                { data: 'Name', title: 'Name' }
            ],
            order: [[0, 'asc']],
            data: selectedMilestones
        });

        $('#custom-selected-milestone-dt-search').on('input', function () {
            $('#selected-milestones-table').DataTable().search(String($(this).val() ?? '')).draw();
        });
        $('#clear-selected-milestone-dt-search').on('click', function () {
            $('#custom-selected-milestone-dt-search').val('');
            $('#selected-milestones-table').DataTable().search('').draw();
        });
    }

    refreshSelectedMilestonesTable(newMilestonesJson: any[]) {
        const selectedMilestones = newMilestonesJson
            .filter(m => m.StudyMilestoneId && m.StudyMilestoneId !== 0 && m.StudyMilestoneId !== null)
            .sort((a, b) => (a.Order ?? 0) - (b.Order ?? 0));
        this.selectedMilestonesTable.clear();
        this.selectedMilestonesTable.rows.add(selectedMilestones).draw();
    }

    setupEditMilestonesDialog() {
        const self = this;
        $('#editMilestonesDialog').modal({
            backdrop: 'static',
            show: false
        });
        $('#editMilestonesDialog').on('hidden.bs.modal', () => {
            if (self.milestonesTable && self.milestonesTable.dataTable) {
                self.milestonesTable.dataTable.destroy();
                $('#milestones-table').empty();
            }
            $('#custom-milestone-dt-search').val('');
            self.milestonesTable = new CTMSMilestonesTable(self.allMilestonesJson, self.studyId);
        });
        $('#editMilestonesDialog').on('shown.bs.modal', () => {
            if (this.milestonesTable.dataTable) {
                this.milestonesTable.dataTable.columns.adjust();
            }
        });
        $('#saveMilestoneButton').off('click').on('click', function () {
            $('#saveMilestoneButton').prop('disabled', true);
            $('#milestoneSaveSpinner').show();
            const milestones = Array.from(self.milestonesTable.checkedMilestoneIds).map(id => {
                const m = self.milestonesTable.milestones.find(x => x.Id === id);
                return m ? { Id: m.Id, Order: m.Order } : null;
            }).filter(x => x !== null);
            const payload = {
                StudyId: self.studyId,
                Milestones: milestones
            };
            $.ajax({
                url: '/secure/ctms/studies/study-details?handler=SaveStudyMilestones',
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify(payload),
                headers: {
                    "RequestVerificationToken": $('input[name="__RequestVerificationToken"]').val() as string
                },
                success: function (response) {
                    if (response && response.updatedMilestones) {
                        const pascalCaseMilestones = mapKeysToPascalCase(response.updatedMilestones);
                        self.allMilestonesJson = pascalCaseMilestones;
                        self.refreshSelectedMilestonesTable(self.allMilestonesJson);
                    }
                    $('#editMilestonesDialog').modal('hide');
                },
                error: function () {
                    alert('Error saving study milestones.');
                },
                complete: function () {
                    $('#saveMilestoneButton').prop('disabled', false);
                    $('#milestoneSaveSpinner').hide();
                }
            });
        });
    }

    setupEditStudyDialog() {
        const self = this;
        const auditDialog = new AuditHistoryDialog();
        $('#editStudyDialog').on('click', '.ctms-icon-history[data-audit-field]', (evt) => {
            const $icon = $(evt.currentTarget);
            auditDialog.show('Study', self.studyId, $icon.data('audit-field'), $icon.data('audit-label'));
        });
        $('#editStudyDialog').modal({
            backdrop: 'static',
            show: false

        });

        $('#editStudyDialog').on('hidden.bs.modal', function () {
            $('#studyDialogForm').removeClass('ctms-invalid-form');

            const currentName = $('#studyDetailsName').text().trim();
            $('#editStudyDialog input[name="Name"]').val(currentName);
        });

        $('#editStudyDialog .ctms-button-save').off('click').on('click', function (e) {
            const f = document.getElementById('studyDialogForm') as HTMLFormElement;
            if (f.checkValidity()) {
                $('#studyDialogForm').removeClass('ctms-invalid-form');
                const formData = $('#editStudyDialog .ctms-field-submit').serialize();
                $('#editStudyDialog .ctms-button-save').prop('disabled', true);
                $('#editStudySaveSpinner').show();
                $.ajax({
                    url: `/secure/ctms/studies/study-details?handler=UpdateStudyDetails&id=${self.studyId}`,
                    headers: { "RequestVerificationToken": self.token },
                    type: 'POST',
                    data: formData,
                    success: function (resp) {
                        if (resp && resp.Name) {
                            $(".ctms-breadcrumb-detail").text(' ' + resp.Name);
                            $("#studyDetailsName").text(resp.Name);
                            $('#editStudyDialog input[name="Name"]').val(resp.Name);
                        }
                        $('#editStudyDialog').modal('hide');
                    },
                    error: function () {
                        alert('Error updating study details.');
                        const f = document.getElementById('studyDialogForm') as HTMLFormElement;
                        f.reset();
                        $('#editStudyDialog').modal('hide');
                    },
                    complete: function () {
                        $('#editStudyDialog .ctms-button-save').prop('disabled', false);
                        $('#editStudySaveSpinner').hide();
                    }
                });
            } else {
                $('#studyDialogForm').addClass('ctms-invalid-form');
            }
            e.preventDefault();
            e.stopPropagation();
        });
    }

    setupEditStudySiteButton() {
        const self = this;
        $('#addSiteButton').off('click').on('click', function () {
            $.ajax({
                url: `/secure/ctms/studies/study-details?handler=SiteSettingsDto&id=${self.studyId}`,
                method: 'GET',
                headers: { "RequestVerificationToken": self.token },
                success: function (resp) {
                    if (resp && resp.success && resp.studySite) {
                        self.allSiteSettings = mapKeysToPascalCase(resp.studySite.allSites) || [];
                        self.assignedSites = resp.studySite.assignedSites || [];
                        self.checkedSiteIds = new Set(self.assignedSites);
                        self.showEditStudySitesModal();
                        if (self.editStudySitesTable) self.editStudySitesTable.draw();
                    } else {
                        alert('Could not load site settings.');
                    }
                },
                error: function () {
                    alert('Error loading site settings.');
                }
            });
        });
    }

    showEditStudySitesModal() {
        const self = this;
        if (self.editStudySitesTable) {
            self.editStudySitesTable.destroy();
            $('#edit-study-sites-table').empty();
        }
        self.editStudySitesTable = $('#edit-study-sites-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '40vh',
            scrollCollapse: true,
            orderCellsTop: true,
            columns: [
                {
                    data: null,
                    title: '<input type="checkbox" id="edit-study-sites-header-checkbox" />',
                    className: "ctms-table-col-check",
                    orderable: false,
                    render: function (data, type, row) {
                        return `<input type="checkbox" class="assign-site-checkbox" data-id="${row.Id}" />`;
                    }
                },
                { data: 'SiteNumber', title: 'Site Number', width: '120px' },
                { data: 'SiteName', title: 'Site Name' }
            ],
            order: [[1, 'asc']],
            data: self.allSiteSettings
        });

        $('#edit-study-sites-header-checkbox').on('change', function () {
            const isChecked = $(this).prop('checked');

            self.editStudySitesTable.rows({ search: 'applied' }).every(function () {
                const rowData = this.data();
                const $row = $(this.node());
                const $checkbox = $row.find('.assign-site-checkbox');

                if (isChecked) {
                    self.checkedSiteIds.add(rowData.Id);
                    $checkbox.prop('checked', true);
                } else {
                    self.checkedSiteIds.delete(rowData.Id);
                    $checkbox.prop('checked', false);
                }
            });
        });

        $('#filter-studySite-search-input').on('input', function () {
            $('#edit-study-sites-table').DataTable().search(String($(this).val() ?? '')).draw();
        });
        $('#filter-studySite-search-clear').on('click', function () {
            $('#filter-studySite-search-input').val('');
            $('#edit-study-sites-table').DataTable().search('').draw();
        });
        // Listen for checkbox changes
        $('#edit-study-sites-table tbody').on('change', '.assign-site-checkbox', function () {
            const id = Number($(this).attr('data-id'));
            if ($(this).prop('checked')) {
                self.checkedSiteIds.add(id);
            } else {
                self.checkedSiteIds.delete(id);
            }
            self.updateStudySitesTableHeaderCheckboxState();
        });
        // On table draw, restore checked state
        self.editStudySitesTable.on('draw', function () {
            self.editStudySitesTable.rows().every(function () {
                const $row = $(this.node());
                const rowData = this.data();
                const $checkbox = $row.find('.assign-site-checkbox');
                if ($checkbox.length && self.checkedSiteIds.has(rowData.Id)) {
                    $checkbox.prop('checked', true);
                } else {
                    $checkbox.prop('checked', false);
                }
            });
            self.updateStudySitesTableHeaderCheckboxState();
        });
        $('#newSiteDialog').modal({
            backdrop: 'static',
            show: true
        });
    }

    updateStudySitesTableHeaderCheckboxState(): void {
        const $headerCheckbox = $('#edit-study-sites-header-checkbox');
        const visibleRows: any[] = [];

        this.editStudySitesTable.rows({ search: 'applied' }).every(function () {
            visibleRows.push(this.data());
        });

        if (visibleRows.length === 0) {
            $headerCheckbox.prop('checked', false);
            $headerCheckbox.prop('indeterminate', false);
            return;
        }

        const checkedCount = visibleRows.filter(row => this.checkedSiteIds.has(row.Id)).length;

        if (checkedCount === 0) {
            $headerCheckbox.prop('checked', false);
            $headerCheckbox.prop('indeterminate', false);
        } else if (checkedCount === visibleRows.length) {
            $headerCheckbox.prop('checked', true);
            $headerCheckbox.prop('indeterminate', false);
        } else {
            $headerCheckbox.prop('checked', false);
            $headerCheckbox.prop('indeterminate', true);
        }
    }

    setupSaveStudySiteAssignment() {
        const self = this;
        $('#saveStudySiteAssignment').off('click').on('click', function () {
            const assignedSites = Array.from(self.checkedSiteIds);
            const formData = new FormData();
            formData.append('Id', String(self.studyId));
            formData.append('AssignedSites', JSON.stringify(assignedSites));
            $('#saveStudySiteAssignment').prop('disabled', true);
            $('#studySiteAssignmentSaveSpinner').show();
            $.ajax({
                url: `/secure/ctms/studies/study-details?handler=SaveStudySites`,
                method: 'POST',
                cache: false,
                contentType: false,
                processData: false,
                data: formData,
                headers: { "RequestVerificationToken": self.token },
                success: function (resp) {
                    if (resp && resp.success && resp.studySites) {
                        self.updateSitesTable(resp.studySites);
                        $('#newSiteDialog').modal('hide');
                    } else {
                        alert('Could not save site assignment.');
                    }
                },
                error: function () {
                    alert('Error saving site assignment.');
                },
                complete: function () {
                    $('#saveStudySiteAssignment').prop('disabled', false);
                    $('#studySiteAssignmentSaveSpinner').hide();
                }
            });
        });
    }

    updateSitesTable(newSites: any[]) {
        var updateSites = mapKeysToPascalCase(newSites) || [];
        updateSites.forEach(site => {
            if (site.CtmsStudy) site.CTMSStudy = site.CtmsStudy;
        });
        this.sites = plainToClass(SiteLevelSummaryDto, <SiteLevelSummaryDto[]>updateSites);
        this.sites = this.sites.map((site: SiteLevelSummaryDto) => {
            site.initialize();
            return site;
        });
        if (this.dataTable) {
            this.dataTable.clear();
            this.dataTable.rows.add(this.sites).draw();
        }
        this.initializeFilters();
    }
}

function mapKeysToPascalCase(obj: any): any {
    if (Array.isArray(obj)) {
        return obj.map(mapKeysToPascalCase);
    }
    if (obj !== null && typeof obj === 'object') {
        const newObj: any = {};
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
                newObj[pascalKey] = mapKeysToPascalCase(obj[key]);
            }
        }
        return newObj;
    }
    return obj;
}